var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEBook2 = function SvgEBook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "e-book2_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e-book2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10h6V8.5H7zm.5 2.5h5V11h-5zM6 19q-.618 0-1.06-.44a1.45 1.45 0 0 1-.44-1.06v-15q0-.687.406-1.094Q5.313 1.001 6 1h8q.619 0 1.06.44.44.442.44 1.06v3q.417 0 .708.292.292.291.292.708v2a.96.96 0 0 1-.292.708.96.96 0 0 1-.708.292v8q0 .62-.44 1.06-.442.44-1.06.44zm0-1.5h8v-15H6z"
  }))));
};
export default SvgEBook2;